module.exports = __webpack_public_path__ + "static/media/intro2.06bd06bc.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/intro2.png
// module id = 226
// module chunks = 0